import { createUseStyles } from 'react-jss'
import { zIndexLoader } from '../../../styles/const/common'
import { mainBackgroundColor } from '../../../styles/const/colors'
import { sideMenuWidth } from '../../../features/components/Header/AuthorizedHeader/style'

export default createUseStyles({
  screensaver: {
    // don't cover the Header/Menu
    position: ({ showTopMenu, showSideMenu }) => (showTopMenu || showSideMenu ? 'fixed' : 'absolute'),
    top: ({ showTopMenu }) => (showTopMenu ? 100 : 0),
    left: ({ showSideMenu }) => (showSideMenu ? sideMenuWidth : 0),
    minWidth: ({ showSideMenu }) => (showSideMenu ? `calc(100vW - ${sideMenuWidth}px)` : '100vW'),
    minHeight: ({ showTopMenu }) => (showTopMenu ? 'calc(100vh - 100px)' : '100vh'),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: mainBackgroundColor,
    zIndex: zIndexLoader,

    '& svg': {
      width: 120,
      height: 'auto'
    }
  }
})
